import React, { Component, useState, useEffect } from "react"
import { BrowserRouter as Router, Route, useLocation, Switch } from "react-router-dom"
import { Redirect } from "react-router-dom"
import jwt from "jsonwebtoken"

import AuthdLayout from "./Layouts/AuthdLayout/"
import NonAuthdLayout from "./Layouts/NonAuthdLayout/"
import "./assets/scss/theme.scss"

import Dashboard from "./Pages/Dashboard"
import Register from "./Pages/Register"
import Login from "./Pages/Login"
import Logout from "./Pages/Logout"
import ForgotPassword from "./Pages/ForgotPassword"
import Apikeys from "./Pages/Apikeys"
import Learning from "./Pages/Learning"
import Settings from "./Pages/Settings"
import Trending from "./Pages/Trending"
import Activity from "./Pages/Activity"
import CreateCollection from "./Pages/CreateCollection"
import CreateMinter from "./Pages/CreateMinter"
import MintNFT from "./Pages/MintNFT"
import Admin from "./Pages/Admin"
import Credits from "./Pages/Credits"
import ValidateNFT from "./Pages/ValidateNFT"
import ValidateKYC from "./Pages/ValidateKYC"
import Trading from "./Pages/Trading"
import CreateNewTrading from "./Pages/CreateNewTrading"
import TradingDetail from "./Pages/TradingDetail"
import ProfilePage from "./Pages/Profile"
import Leaderboard from "./Pages/Leaderboard"
import Token from "./Pages/Token"
import Staking from "./Pages/Staking"
import Voting from "./Pages/Voting"
import NFTUpgrade from "./Pages/NFTUpgrade"

const AppRoute = ({ Component, Layout, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <Layout>
                <Component {...props} />
            </Layout>
        )}
    />
)

const ProtectedRoute = ({ Level, Component, ...rest }) => {
    const authLevel = { new: 1, tester: 2, developer: 3, admin: 5 }
    const [auth, setAuth] = useState(10)
    const [queryParam, setQueryParam] = useState("")
    const [search, setSearch] = useState("")
    const [hash, setHash] = useState("")
    const location = useLocation()

    useEffect(() => {
        setAuth(0)
        setQueryParam(location.pathname.slice(1))
        setSearch(location.search)
        setHash(location.hash)
        if (localStorage.jwtToken) {
            try {
                var decoded = jwt.decode(localStorage.jwtToken)
                if (new Date().getTime() > decoded.exp * 1000) {
                    localStorage.removeItem("jwtToken")
                } else {
                    setAuth(authLevel[decoded.type])
                }
            } catch {}
        }
    }, localStorage)

    return (
        <Route
            {...rest}
            render={(props) =>
                auth >= Level ? (
                    <AuthdLayout>
                        <Component {...props} />
                    </AuthdLayout>
                ) : queryParam !== "" ? (
                    <Redirect to={{ pathname: "/login", state: { referrer: queryParam, search, hash } }} />
                ) : (
                    <Redirect to={{ pathname: "/login" }} />
                )
            }
        />
    )
}

class App extends Component {
    constructor(props) {
        super(props)
        this.state = { authenticated: true }
    }

    componentDidMount() {}

    render() {
        return (
            <Router>
                <Switch>
                    <ProtectedRoute Level={1} exact path="/" Component={Dashboard} />
                    <ProtectedRoute Level={1} exact path="/validatenft" Component={ValidateNFT} />
                    <ProtectedRoute Level={1} exact path="/nftupgrade" Component={NFTUpgrade} />
                    <ProtectedRoute Level={1} exact path="/settings" Component={Settings} />
                    <ProtectedRoute Level={5} exact path="/admin" Component={Admin} />

                    <AppRoute exact path="/register" Layout={NonAuthdLayout} Component={Register} />
                    <AppRoute exact path="/logout" Layout={NonAuthdLayout} Component={Logout} />
                    <AppRoute path="/login" Layout={NonAuthdLayout} Component={Login} />
                    <AppRoute exact path="/forgot-password" Layout={NonAuthdLayout} Component={ForgotPassword} />
                </Switch>
            </Router>
        )
    }
}

export default App
